import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_REQUEST_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class Request extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-permohonan-barang-jasa');
  }

  render() {
    const { handleGetRequest } = this.props;
    return (
      <div className="request">
        <Button
          title="Tambah Surat Permohonan Barang Jasa"
          onClick={this.onClickAdd}
        />
        <div className="request__content">
          <ContentTable
            onSearchContent={handleGetRequest}
            tableFields={PERSONAL_REQUEST_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
Request.propTypes = {
  handleGetRequest: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Request.defaultProps = {
  handleGetRequest: noop,
};
